import React from "react";
import AssessmentGoal from "../../../molecules/Progress/AssessmentGoal/AssessmentGoal";

const Nutritionist = ({
  mode = "view",
  isPrimary,
}: {
  mode?: "view" | "edit";
  isPrimary?: boolean;
}) => {
  return (
    <div>
      <AssessmentGoal activeTab="diet" mode={mode} isPrimary={isPrimary} />
    </div>
  );
};

export default Nutritionist;
